<template>
  <v-dialog
    :value="value"
    max-width="1100"
    scrollable
    @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="d-flex align-center grey lighten-4">
        <v-icon left>
          mdi-factory
        </v-icon>
        Factory Settings
        <v-spacer />
        <v-btn
          icon
          @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text
        ref="scrollArea"
        class="pt-4"
        style="max-height: 70vh;">
        <v-alert
          text
          color="info"
          border="left"
          class="mb-4 text-body-2">
          Configure capacity defaults and monthly overrides per factory.
        </v-alert>

        <v-text-field
          v-model="searchQuery"
          placeholder="Search factory..."
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          clearable
          hide-details
          class="mb-3" />

        <div
          v-if="searchQuery && filteredEditFactories.length === 0"
          class="text-center grey--text py-6">
          <v-icon color="grey lighten-1">
            mdi-factory-off
          </v-icon>
          <div class="text-caption mt-1">
            No factories match "{{ searchQuery }}"
          </div>
        </div>

        <v-expansion-panels
          v-model="openPanels"
          multiple
          flat>
          <v-expansion-panel
            v-for="factory in filteredEditFactories"
            :key="factory.id">
            <v-expansion-panel-header @click="loadOverrides(factory)">
              <div
                class="d-flex align-center"
                style="gap: 12px;">
                <v-icon color="primary">
                  mdi-factory
                </v-icon>
                <div>
                  <div class="text-body-1 font-weight-medium">
                    {{ factory.name }}
                  </div>
                  <div class="text-caption grey--text">
                    {{ factory.productionTypes && factory.productionTypes.length }}
                    production types configured
                  </div>
                </div>
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-form :ref="`form_${factory.id}`">
                <v-row class="mb-3">
                  <!-- <v-col
                    cols="12"
                    md="3">
                    <v-card
                      outlined
                      class="pa-3">
                      <div class="text-caption grey--text text--darken-1 mb-2 font-weight-medium">
                        TENT PCS CAPACITY
                      </div>
                      <v-text-field
                        v-model.number="factory._edit.defaultTentPcs"
                        type="number"
                        :rules="positiveIntRules"
                        outlined
                        dense
                        suffix="pcs"
                        min="0"
                        hide-details />
                      <div class="text-caption grey--text mt-1">
                        Tentative fallback
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3">
                    <v-card
                      outlined
                      class="pa-3">
                      <div class="text-caption grey--text text--darken-1 mb-2 font-weight-medium">
                        PROD PCS CAPACITY
                      </div>
                      <v-text-field
                        v-model.number="factory._edit.defaultProdPcs"
                        type="number"
                        :rules="positiveIntRules"
                        outlined
                        dense
                        suffix="pcs"
                        min="0"
                        hide-details />
                      <div class="text-caption grey--text mt-1">
                        Producing fallback
                      </div>
                    </v-card>
                  </v-col> -->
                  <v-col
                    cols="12"
                    md="6">
                    <v-card
                      outlined
                      class="pa-3">
                      <div class="text-caption grey--text text--darken-1 mb-2 font-weight-medium">
                        Capacity การผลิตสินค้าตัวอย่าง
                      </div>
                      <v-text-field
                        v-model.number="factory._edit.defaultTentProduct"
                        type="number"
                        :rules="positiveIntRules"
                        outlined
                        dense
                        suffix="products"
                        min="0"
                        hide-details />
                      <div class="text-caption grey--text mt-1">
                        ค่าเริ่มต้นกำลังการผลิต สินค้าตัวอย่าง (Fallback)
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6">
                    <v-card
                      outlined
                      class="pa-3">
                      <div class="text-caption grey--text text--darken-1 mb-2 font-weight-medium">
                        Capacity การผลิตสินค้าสำหรับขาย
                      </div>
                      <v-text-field
                        v-model.number="factory._edit.defaultProdProduct"
                        type="number"
                        :rules="positiveIntRules"
                        outlined
                        dense
                        suffix="products"
                        min="0"
                        hide-details />
                      <div class="text-caption grey--text mt-1">
                        ค่าเริ่มต้นกำลังการผลิต สินค้าสำหรับขาย (Fallback)
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <v-card
                  outlined
                  class="pa-3 mb-3">
                  <div class="text-caption grey--text text--darken-1 mb-2 font-weight-medium">
                    PRODUCTION TYPES
                  </div>
                  <v-chip-group
                    v-model="factory._edit.productionTypes"
                    multiple
                    column>
                    <v-chip
                      v-for="pt in productionTypeOptions"
                      :key="pt.value"
                      :value="pt.value"
                      filter
                      outlined>
                      <v-icon
                        left
                        x-small>
                        {{ pt.icon }}
                      </v-icon>
                      {{ pt.label }}
                    </v-chip>
                  </v-chip-group>
                </v-card>

                <v-card
                  v-if="factory._loadingOverrides || factory._utilization"
                  outlined
                  class="pa-3 mb-3">
                  <div class="text-caption grey--text text--darken-1 mb-2 font-weight-medium">
                    UTILIZATION (CURRENT MONTH)
                  </div>
                  <v-row
                    v-if="factory._loadingOverrides"
                    no-gutters>
                    <v-col
                      v-for="n in 4"
                      :key="n"
                      cols="3"
                      class="pr-3">
                      <v-skeleton-loader type="text" />
                    </v-col>
                  </v-row>
                  <v-row
                    v-else-if="factory._utilization"
                    no-gutters>
                    <v-col cols="4">
                      <div class="text-caption grey--text">
                        Current utilization
                      </div>
                      <div
                        class="text-h6 font-weight-bold"
                        :class="{ 'error--text': factory._utilization.currentUtilization > 100 }">
                        {{ factory._utilization.currentUtilization }}%
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div class="text-caption grey--text">
                        Products assigned
                      </div>
                      <div class="text-h6 font-weight-bold">
                        {{ factory._utilization.productsAssigned }}
                      </div>
                    </v-col>
                    <!-- <v-col cols="3">
                      <div class="text-caption grey--text">
                        PCS utilization
                      </div>
                      <div
                        class="text-h6 font-weight-bold"
                        :class="{ 'error--text': factory._utilization.pcsUtilization > 100 }">
                        {{ factory._utilization.pcsUtilization }}%
                      </div>
                    </v-col> -->
                    <v-col cols="4">
                      <div class="text-caption grey--text">
                        Product utilization
                      </div>
                      <div
                        class="text-h6 font-weight-bold"
                        :class="{ 'error--text': factory._utilization.productUtilization > 100 }">
                        {{ factory._utilization.productUtilization }}%
                      </div>
                    </v-col>
                  </v-row>
                </v-card>

                <v-card
                  outlined
                  class="pa-3 mb-3">
                  <div class="text-caption grey--text text--darken-1 mb-2 font-weight-medium">
                    MONTHLY CAPACITY OVERRIDES
                  </div>
                  <capacity-override-table
                    :ref="`overrideTable_${factory.id}`"
                    :overrides="factory._overrides || []"
                    :loading="factory._loadingOverrides" />
                </v-card>

                <div class="d-flex justify-end">
                  <v-btn
                    depressed
                    color="primary"
                    :loading="factory._saving"
                    class="text-none"
                    @click="saveFactory(factory)">
                    Save {{ factory.name }}
                  </v-btn>
                </div>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import FactoryProvider from '@/resources/FactoryProvider'
import CapacityOverrideTable from './CapacityOverrideTable.vue'

const FactoryService = new FactoryProvider()

export default {
  name: 'FactorySettingsDialog',
  components: { CapacityOverrideTable },
  props: {
    value: Boolean,
    factories: { type: Array, default: () => [] }
  },
  data () {
    return {
      openPanels: [],
      editFactories: [],
      searchQuery: '',
      productionTypeOptions: [
        { value: 'WOVEN', label: 'Woven', icon: 'mdi-grid' },
        { value: 'JERSEY', label: 'Jersey', icon: 'mdi-tshirt-crew' },
        { value: 'ACTIVEWEAR', label: 'Activewear', icon: 'mdi-run' },
        { value: 'JEANS', label: 'Jeans', icon: 'mdi-hanger' },
        { value: 'KNIT', label: 'Knit', icon: 'mdi-vector-combine' },
        { value: 'BAG', label: 'Bag', icon: 'mdi-bag-personal' },
        { value: 'ACC', label: 'Acc', icon: 'mdi-necklace' },
        { value: 'FOOTWEAR', label: 'Footwear', icon: 'mdi-shoe-sneaker' },
        { value: 'EYEWEAR', label: 'Eyewear', icon: 'mdi-glasses' }
      ],
      positiveIntRules: [
        (v) => v == null || v === '' || (Number.isInteger(v) && v >= 0) || 'Must be 0 or a positive integer'
      ]
    }
  },
  computed: {
    filteredEditFactories () {
      if (!this.searchQuery) return this.editFactories
      const q = this.searchQuery.toLowerCase()
      return this.editFactories.filter((f) => f.name.toLowerCase().includes(q))
    }
  },
  watch: {
    value (val) {
      if (val) {
        this.searchQuery = ''
        this.initEditState()
        this.$nextTick(() => {
          const el = this.$refs.scrollArea?.$el || this.$refs.scrollArea
          if (el) el.scrollTop = 0
        })
      } else {
        this.openPanels = []
      }
    }
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar'
    }),
    initEditState () {
      this.editFactories = this.factories.map((f) => ({
        ...f,
        _edit: {
          name: f.name,
          factoryTimelineId: f?.factoryTimelineId || null,
          defaultTentPcs: f.defaultTentPcs || 0,
          defaultProdPcs: f.defaultProdPcs || 0,
          defaultTentProduct: f.defaultTentProduct || 0,
          defaultProdProduct: f.defaultProdProduct || 0,
          productionTypes: f.productionTypes ? [...f.productionTypes] : []
        },
        _overrides: [],
        _utilization: null,
        _loaded: false,
        _loadingOverrides: false,
        _saving: false
      }))
    },
    async loadOverrides (factory) {
      // if (factory._loaded) return
      this.$set(factory, '_loadingOverrides', true)
      try {
        const [{ data: overrides }, { data: utilization }] = await Promise.all([
          FactoryService.getCapacityOverrides(factory.id),
          FactoryService.getUtilizationSummary(factory.id)
        ])
        this.$set(factory, '_overrides', overrides)
        this.$set(factory, '_utilization', utilization)
        this.$set(factory, '_loaded', true)
      } catch (e) {
        console.error('loadOverrides', e?.message || e)
        this.setSnackbar({ value: true, message: `Error loading overrides: ${e?.message || e}`, type: 'error' })
      } finally {
        this.$set(factory, '_loadingOverrides', false)
      }
    },
    async saveFactory (factory) {
      const formRef = this.$refs[`form_${factory.id}`]
      const form = Array.isArray(formRef) ? formRef[0] : formRef
      if (form && !form.validate()) {
        this.setSnackbar({ value: true, message: 'Please fix invalid capacity values before saving', type: 'error' })
        return
      }
      this.$set(factory, '_saving', true)
      try {
        await FactoryService.updateOne(factory.id, factory._edit)
        const tableRef = this.$refs[`overrideTable_${factory.id}`]

        if (tableRef.length > 0) {
          const changed = (tableRef[0]?.getChangedRows() || []).map((row) => ({
            ...row,
            prodPcs: Number.isFinite(row?.prodPcs) ? row.prodPcs : null,
            prodProd: Number.isFinite(row?.prodProd) ? row.prodProd : null,
            tentPcs: Number.isFinite(row?.tentPcs) ? row.tentPcs : null,
            tentProd: Number.isFinite(row?.tentProd) ? row.tentProd : null
          }))

          if (changed.length > 0) {
            await FactoryService.updateCapacityOverrides(factory.id, { overrides: changed })
          }
        }
        this.$emit('saved')
        this.setSnackbar({ value: true, message: `${factory.name} saved`, type: 'success' })
      } catch (e) {
        console.error('saveFactory', e?.message || e)
        this.setSnackbar({ value: true, message: `Error: ${e?.message || e}`, type: 'error' })
      } finally {
        this.$set(factory, '_saving', false)
      }
    }
  }
}
</script>
